<oe-chart [title]="'GENERAL.SELF_CONSUMPTION' | translate">
    <selfconsumptionChart [isOnlyChart]="true">
    </selfconsumptionChart>
</oe-chart>
